export default {
  bodyTags: [],
  headTags: [
    {
      tagName: 'script',
      attributes: {
        src: 'https://s3-us01.didiglobal.com/payrisk-mid-platform/freya-kyc/vue.2.7.16.js',
        crossorigin: 'anonymous',
      },
    },
    {
      tagName: 'script',
      attributes: {
        src: 'https://s3-us01.didiglobal.com/payrisk-mid-platform/freya-kyc/vue-router.3.6.5.js',
        crossorigin: 'anonymous',
      },
    },
    {
      tagName: 'script',
      attributes: {
        src: 'https://s3-us01.didiglobal.com/payrisk-mid-platform/freya-kyc/vuex.3.6.2.js',
        crossorigin: 'anonymous',
      },
    },
  ],
}
